import { render, staticRenderFns } from "./edit-expense.vue?vue&type=template&id=94b3a12a&"
import script from "./edit-expense.vue?vue&type=script&lang=js&"
export * from "./edit-expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports